import { CmtsAdminIdentityPage } from "../components/admin/index.js";
import { cmtsRolesAdminIdentityConfig } from "../config/adminIdentity.config.js";

export function CmtsRolesPage() {
  return <CmtsAdminIdentityPage config={cmtsRolesAdminIdentityConfig} />;
}

export default CmtsRolesPage;
